import { MONTHS_G_CASE } from 'src/constants/calendar';

interface DayMonthSpanProps {
  dateAsNumber: number;
}

export default function DayMonthSpan({ dateAsNumber }: Readonly<DayMonthSpanProps>) {
  const locale = 'uk-UA';
  const date = new Date(dateAsNumber);
  const dateString = date.toLocaleDateString(locale, { dateStyle: 'long' });

  return (
    <span>
      <time dateTime={dateString}>{date.getDate()}&nbsp;</time>
      <time>{MONTHS_G_CASE[date.getMonth()]}</time>
    </span>
  );
}
